import { render, staticRenderFns } from "./UserLogworks.vue?vue&type=template&id=725dc1f1&scoped=true&"
import script from "./UserLogworks.vue?vue&type=script&lang=ts&"
export * from "./UserLogworks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725dc1f1",
  null
  
)

export default component.exports